"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateReviewSchema = void 0;
var zod_1 = require("zod");
var types_1 = require("./types");
var UpdateReviewDataSuccessSchema = types_1.MutateReviewDataSuccessSchema;
var UpdateReviewDataFailedSchema = types_1.MutateReviewDataFailedSchema;
var UpdateReviewDataSchema = zod_1.z.union([UpdateReviewDataSuccessSchema, UpdateReviewDataFailedSchema]);
/**
 * 후기 수정 완료 응답
 */
exports.UpdateReviewSchema = zod_1.z.object({
    data: UpdateReviewDataSchema,
});
